import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import OrganizationSetDetailPage from '@/pages/organizations/detail/sets/detail'
import HgSkeletonPage from '@/common/components/ui/atoms/HgSkeletonPage'
import { find } from 'lodash'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/sets/$setId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { setId } = Route.useParams()
  const { assessments, assessmentsLoading, permissionsChecked } = useOrganization()

  const assessment = find(assessments, (_a) => {
    return Number(_a.id) === Number(setId)
  })

  // Show loading state while permissions or assessments are loading
  // assessmentsLoading is a counter: undefined (not started), > 0 (loading), 0 (done)
  if (!permissionsChecked || assessmentsLoading !== 0) {
    return <HgSkeletonPage />
  }

  if (assessment) {
    // OrganizationSetDetailPage is a layout component that provides context and renders <Outlet />
    return <OrganizationSetDetailPage assessment={assessment} />
  }

  // Assessment not found after loading completed
  return null
}
